module.exports = __webpack_public_path__ + "static/media/edu-games-plus-logo.b36f3360.svg";